import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import PageTitle from '@/components/v2/PageTitle.vue';
import ProductDetailsMixin from '@/helpers/vue_mixins/v2/ecommerce/ProductDetailsMixin';
import BaseDetailsCard from '@/components/v2/BaseDetailsCard';
import BaseDetails from '@/components/v2/BaseDetails';
import ActionButton from '@/components/action_button/Index.vue';
import BaseImageThumbnail from '@/components/v2/BaseImageThumbnail';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let ProductsDetails = class ProductsDetails extends Mixins(ProductDetailsMixin, ViewportSizeMixin) {
    get productCategory() {
        if (this.product?.digitalProduct) {
            return 'Digital Product';
        }
        if (this.product?.category === 'freebie') {
            return 'Freebie';
        }
        return 'Physical Product';
    }
    get percentageDiscount() {
        if (this.product?.activePromo) {
            const { discountType } = this.product.activePromo;
            return discountType === 'percentage';
        }
        return false;
    }
    goToProductEditPage() {
        this.$router.push({
            name: 'ecommerce-products-edit',
            params: {
                uuid: this.uuid,
            },
        });
    }
    setVariantNames(variance) {
        let variantName = '';
        variance.productOptions.edges.forEach((i, idx, array) => {
            variantName = variantName.concat(i.node.name);
            if (idx !== array.length - 1) {
                variantName = variantName.concat(' - ');
            }
        });
        return variantName;
    }
    get imageSize() {
        if (this.smAndUp) {
            return '184';
        }
        return '90';
    }
};
ProductsDetails = __decorate([
    Component({
        components: {
            PageTitle,
            BaseDetails,
            BaseDetailsCard,
            ActionButton,
            BaseImageThumbnail,
        },
    })
], ProductsDetails);
export default ProductsDetails;
